// Kantenumleimer (Kantenband) einer Platte — in part.meta.edges.
// Kanten auf der L×B-Fläche: l1/l2 = Längskanten (bei ∓B), b1/b2 = Querkanten (bei ∓L).

export const EDGE_KEYS = ["l1", "l2", "b1", "b2"]

export function edgesOf(part) {
  return part.meta?.edges ?? []
}

export function withEdges(part, edges) {
  return { ...part.meta, edges: EDGE_KEYS.filter((key) => edges.includes(key)) }
}

export function toggleEdge(part, key) {
  const current = edgesOf(part)
  return withEdges(part, current.includes(key) ? current.filter((k) => k !== key) : [...current, key])
}

export function edgeLengthMm(part, key) {
  return key.startsWith("l") ? part.length_mm : part.width_mm
}

export function totalEdgeBandMm(part) {
  return edgesOf(part).reduce((sum, key) => sum + edgeLengthMm(part, key), 0)
}
